import { useMemo } from 'react';
import { useTheme } from '@naruto/naruto-theme/src/common';
import { Theme } from '@mui/material/styles';

export type useMaterialTheme = Theme;

/**
 * 描述 : 取得 Material UI 的主題
 */
export default function useMaterialTheme(): useMaterialTheme {
  /* Global & Local State */
  const theme = useTheme();
  /* Main */
  return useMemo(() => theme, [theme]);
}
